export function cloneDeep<T>(obj: T): T {
	if (obj === null || typeof obj !== 'object' || obj instanceof File) {
		return obj;
	}

	if (obj instanceof File) {
		return new File([obj], obj.name, { type: obj.type }) as T;
	}

	if (obj instanceof Blob) {
		return new Blob([obj], { type: obj.type }) as T;
	}

	if (Array.isArray(obj)) {
		const arrObj = obj as unknown as any[];
		return arrObj.map(cloneDeep) as unknown as T;
	}

	if (obj instanceof RegExp) {
		return new RegExp(obj.source, obj.flags) as T;
	}

	if (obj instanceof Date) {
		return new Date(obj.getTime()) as T;
	}

	if (obj instanceof Map) {
		const copy = new Map();
		for (let [key, value] of obj) {
			copy.set(cloneDeep(key), cloneDeep(value));
		}
		return copy as T;
	}

	if (obj instanceof Set) {
		const copy = new Set();
		for (let value of obj) {
			copy.add(cloneDeep(value));
		}
		return copy as T;
	}

	if (obj instanceof Object) {
		const copy = {} as unknown as Record<any, any>;
		for (let attr in obj as any) {
			if ((obj as any).hasOwnProperty(attr)) {
				copy[attr] = cloneDeep((obj as any)[attr]);
			}
		}
		return copy;
	}

	return obj;
}
